export default [
  {
    // Greendale Community College
    purchaserId: '10002',
    id: 'PROPLUS-AI1',
    name: 'Showbie Pro Plus',
    features: [
      'ADMINREPORTS',
      'AI',
      'SOCRATIVE',
      'UNLIMITEDUPLOAD',
      'VIDEOCHAT',
    ],
  },
  {
    // City College
    purchaserId: '10003',
    id: 'COMPLETE-1',
    name: 'Showbie Complete',
    features: [
      'ADMINREPORTS',
      'AI',
      'EXPLAINEVERYTHING',
      'SOCRATIVE',
      'UNLIMITEDUPLOAD',
      'VIDEOCHAT',
    ],
  },
  // this is to test service errors after attempting to toggle the AI feature
  {
    // Clone High
    purchaserId: '11000',
    id: 'COMPLETE-11',
    name: 'Showbie Complete',
    features: [
      'ADMINREPORTS',
      'AI',
      'EXPLAINEVERYTHING',
      'SOCRATIVE',
      'UNLIMITEDUPLOAD',
      'VIDEOCHAT',
    ],
  },
];
